import React, { useState } from 'react';
import {
  View,
  StyleSheet,
  LayoutChangeEvent,
  Image,
} from 'react-native';
import { ResizeMode, Video } from 'expo-av';
import { useObserver } from 'mobx-react-lite';
import { SCREEN_HEIGHT, SCREEN_WIDTH } from '../../../Config/Constant';
import { CUBE_RED } from '../../../Config/Color';
import { sectionHeightRepository } from '../../../Domain/Repositories/SectionHeightRepository';
import SectionTypes from '../../../Domain/Types/SectionTypes';
import SocialSharingToolbar from '../../Shared/SocialSharingToolbar';
import { sessionRepository } from '../../../Domain/Repositories/SessionRepository';
import BulletTimePlaceholder from '../../../Images/Icons/Cube.jpeg';

/**
 * Renders the Bullet Time Sub-Component.
 * @returns JSX.Element.
 */
export default function BulletTime(): JSX.Element
{
  const [sharingOpacity, setSharingOpacity] = useState(0);

  const onLayout = (event: LayoutChangeEvent): void =>
  {
    sectionHeightRepository.updateSectionHeight(SectionTypes.BulletTime, event);
  };

  return useObserver(() => (
    <View
      onLayout={onLayout}
      style={styles.container}
      onMouseEnter={(): void => setSharingOpacity(1)}
      onMouseLeave={(): void => setSharingOpacity(0)}
    >
      <View style={styles.backgroundMain}>
        <View style={styles.backgroundLeft} />
        <View style={styles.backgroundRight} />
      </View>
      <View style={styles.backgroundMainOverlay} />

      <Image
        source={BulletTimePlaceholder}
        resizeMode={ResizeMode.COVER}
        style={styles.videoBackground}
      />

      <View style={styles.socialSharingView}>
        <SocialSharingToolbar
          opacity={sharingOpacity}
          containerWidth={undefined}
          containerHeight="30%"
          borderRadius={SCREEN_WIDTH * 0.05}
        />
      </View>
    </View>
  ));
}

const styles = StyleSheet.create({
  container: {
    height: SCREEN_HEIGHT * 0.35,
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
  },
  backgroundMain: {
    width: '100%',
    height: '100%',
    flexDirection: 'row',
    position: 'absolute',
  },
  backgroundMainOverlay: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    backgroundColor: 'white',
    opacity: 0.05,
  },
  backgroundLeft: {
    flex: 1,
    backgroundColor: 'black',
    opacity: 0.75,
  },
  backgroundRight: {
    flex: 1,
    backgroundColor: CUBE_RED(),
    opacity: 0.85,
  },
  videoBackground: {
    position: 'absolute',
    height: '65%',
    width: undefined,
    aspectRatio: 1.75,
    alignSelf: 'center',
    opacity: 1,
    borderWidth: SCREEN_HEIGHT * 0.002,
    borderColor: 'white',
    borderTopLeftRadius: SCREEN_WIDTH * 0.01,
    borderBottomRightRadius: SCREEN_WIDTH * 0.01,
    shadowColor: CUBE_RED(),
    shadowOffset: {
      width: 1,
      height: 1,
    },
    shadowOpacity: 1,
    shadowRadius: 30,
    backgroundColor: 'black',
    justifyContent: 'center',
  },
  socialSharingView: {
    position: 'absolute',
    width: '50%',
    height: '30%',
    alignSelf: 'center',
    justifyContent: 'flex-end',
    alignItems: 'center',
    bottom: '5%',
  },
});
